import React, {useState} from "react";

export default function StaffWarningPicker({
  title, warnings, onClose, onSelect
}) {
  const [selected, setSelected] = useState(null);

  return (
    <div role="presentation" style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(0, 0, 0, 0.82)",
      display: "grid", placeItems: "center", padding: 16
    }}>
      <div role="dialog" aria-modal="true" aria-label={title}
        style={{
          width: "min(100%, 620px)", maxHeight: "88vh",
          display: "flex", flexDirection: "column",
          background: "#071b2a", color: "#fff",
          border: "1px solid #00c8ee", borderRadius: 14,
          padding: 18
        }}>
        <h2 style={{marginTop: 0}}>{title}</h2>
        <p style={{color: "#a8c6d4", marginTop: 0}}>
          Choisissez un motif. Seule la personne indiquée recevra
          cet avertissement.
        </p>
        <div style={{overflowY: "auto", flex: 1}}>
          {warnings.map((item, index) => (
            <label key={item.label} style={{
              display: "block", padding: 10, marginBottom: 7,
              border: selected === index
                ? "1px solid #00eaff" : "1px solid #285064",
              borderRadius: 9, cursor: "pointer"
            }}>
              <input type="radio" name="staff-warning"
                checked={selected === index}
                onChange={() => setSelected(index)}
                style={{marginRight: 9}} />
              <span style={{color: "#fff"}}>
                {item.message}
              </span>
            </label>
          ))}
        </div>
        <div style={{display: "flex", gap: 10, marginTop: 16}}>
          <button type="button" onClick={onClose}>Annuler</button>
          <button type="button" disabled={selected === null}
            onClick={() => onSelect(warnings[selected].message)}
            style={{
              padding: "10px 14px", color: "#001921",
              background: "#ffcf6a", border: 0,
              borderRadius: 8, fontWeight: 800,
              cursor: "pointer"
            }}>
            Envoyer l’avertissement
          </button>
        </div>
      </div>
    </div>
  );
}
